import { render, staticRenderFns } from "./GBoothPickupForm.vue?vue&type=template&id=d643fbc6&scoped=true&"
import script from "./GBoothPickupForm.vue?vue&type=script&lang=ts&"
export * from "./GBoothPickupForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBoothPickupForm.vue?vue&type=style&index=0&id=d643fbc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d643fbc6",
  null
  
)

export default component.exports